<template>
  <!--================ banner =================-->
  <section v-if="bannerTopo != ''" class="breadcrumb_area">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'about_banner.jpg'" alt="">
    </div>
    <div class="container">
      <div class="page-cover text-center">
        <h2 class="page-cover-tittle">{{ bannerTopo[0].itiNome }}</h2>
        <ol class="breadcrumb">
          <li><router-link to="/">Home / </router-link></li>
          <li>{{ bannerTopo[0].itiNome }}</li>
          <li v-if="listaServicos != ''"> / <strong>{{ listaServicos.itiNome }} {{ listaServicos.itiReferencia }}</strong></li>
        </ol>
      </div>
    </div>
  </section>

  <!--================ Características ====================-->
  <section class="caracteristicas">
    <div v-if="listaServicos.insInstitucionalGrids?.length" class="container">
      <div class="row justify-content-center">

        <!-- Coluna 1 -->
        <div v-for="caracteristica in listaServicos.insInstitucionalGrids.filter(item => item.insListaGaleriaInstGrids?.lgtId === 6)" :key="caracteristica.igsId" class="col-lg-3 col-md-6 col-sm-12 carac-cel">
          <div class="caracteristicas-card h-100 text-center p-4">
            <h3 class="caracteristicas-titulo">{{ caracteristica.igsNome }}</h3>
            <p v-html="caracteristica.igsResumo"></p>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!--================ detalhe do serviço 1 =================-->
  <section v-if="listaServicos != ''" class="about_history_area section_gap">
    <div class="container">
      <div class="row">
        <div class="col-md-6 d_flex align-items-center">
          <div class="about_content ">
            <h2 class="title title_color">{{ listaServicos.itiNome }}</h2>
            <p v-html="listaServicos.itiResumo1"></p>
            
          </div>
        </div>
        <div v-if="listaServicos != ''" class="col-md-6 img-avance hidden-sm hidden-xs">
          <img class="img-fluid" :src="$imgURL + listaServicos.insInstitucionalImagens[0].itgUrlImagem" alt="img">
        </div>
      </div>
    </div>
  </section>

  <!--================ detalhe do serviço 2 =================-->
  <section v-if="listaServicos != ''" class="about_history_area section_gap-2">
    <div class="container">
      <div class="row">

        <div v-if="listaServicos.insInstitucionalImagens.length > 0" class="col-md-6 img-avance">
          <img class="img-fluid" :src="$imgURL + listaServicos.insInstitucionalImagens[1].itgUrlImagem" alt="img">
        </div>

        <div class="col-md-6 d_flex align-items-center">
          <div class="about_content ">
            <h2 class="title title_color">{{ listaServicos.itiReferencia }} </h2>
            <p v-html="listaServicos.itiResumo2"></p>
            
          </div>
        </div>

      </div>
    </div>
  </section>

  <!--=============== call to action ====================-->
  <PageCallAction></PageCallAction>

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';
import PageCallAction from '@/components/PageCallAction.vue';

export default {
  name: 'ServicosDetalheView',
  components: {
    PageCallAction,
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    listaServicos: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Imob - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Garante Imob" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
          { name: "keywords", content: "" }
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    // bannerTopo
    axios.get('/Process/InsInstitucional/institucional/61/toposervicos/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('bannertopo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // lista serviços
    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.listaServicos = response.data;
        // novo array filtrado
        this.listaServicosFiltrados = response.data.insInstitucionalGrids.filter(
          item => item.insListaGaleriaInstGrids?.lgtId === 6
        );
        this.carregaMetas(this.removerTagsHTML(this.listaServicos.itiReferencia), this.listaServicos.itiNome);
        console.log('listaServicos')
        console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>